import { createFileRoute } from '@tanstack/react-router';
import Memberships from 'src/pages/Organization/Reports/Memberships';

export const Route = createFileRoute('/$organizationSlug/reports/')({
  component: Memberships,
});
